<!--
Komponente für die Darstellung von Fehlermeldungen an den Benutzer.
-->
<template>
  <div>
    <b-modal v-model="showMessage" :title="t('error')" header-bg-variant="danger" header-text-variant="light" centered>
      <p class="pre-formatted">{{ message }}</p>
      <template #modal-footer>
        <b-button variant="primary" block @click="showMessage = false">Ok</b-button>
      </template>
    </b-modal>
  </div>
</template>

<i18n>
en:
  error: "Error"
de:
  error: "Fehler"
</i18n>

<script setup>
import { defineExpose, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { Logger } from "@/logger/logger";

const log = new Logger("ErrorModal");

const { t } = useI18n()

const message = ref("");
const showMessage = ref(false);

const error = (msg) => {
  log.error(msg);
  showMessage.value = true;
  message.value = msg;
}

defineExpose({
  error
})
</script>

<style scoped>
.pre-formatted {
  white-space: pre-wrap;
}
</style>
